// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"523":"96b6ecca8ec8f323","909":"5ddea6148d25c9de"}[chunkId] + ".js";
};